export default __webpack_public_path__ + "static/media/mv.ca073416.svg";